(() => {
  const SHIPPING_PATH = '/policies/shipping-policy';
  const PRIVACY_PATH = '/policies/privacy-policy';

  function normalizePath(pathname) {
    return pathname.replace(/\/+$/, '') || '/';
  }

  function buildToc(headings) {
    const list = document.createElement('ol');
    list.className = 'tr-shipping-toc';

    headings.forEach((heading, index) => {
      const item = document.createElement('li');
      const link = document.createElement('a');
      const number = document.createElement('span');
      const label = document.createElement('span');

      number.className = 'tr-shipping-number';
      number.textContent = String(index + 1).padStart(2, '0');
      label.textContent = heading.textContent.replace(/^\s*\d+\.\s*/, '').trim();
      link.href = `#${heading.id}`;
      link.append(number, label);
      item.append(link);
      list.append(item);
    });

    return list;
  }

  function enhanceShippingPolicy() {
    const currentPath = normalizePath(window.location.pathname);
    if (currentPath !== SHIPPING_PATH && currentPath !== PRIVACY_PATH) return;
    if (currentPath === PRIVACY_PATH && !window.matchMedia('(min-width: 990px)').matches) return;

    const policyBody = document.querySelector('.shopify-policy__body');
    if (!policyBody || policyBody.querySelector('.tr-shipping-shell')) return;

    if (currentPath === PRIVACY_PATH) {
      const legacyArticle = policyBody.querySelector('.tr-privacy-shell .tr-privacy-article');

      if (legacyArticle) {
        const legacyLead = legacyArticle.querySelector(':scope > .tr-privacy-lead');
        const legacyMeta = legacyLead?.querySelector('.tr-privacy-meta');
        const normalizedNodes = [];

        if (legacyMeta) legacyMeta.className = 'tr-shipping-meta';

        Array.from(legacyArticle.childNodes).forEach((node) => {
          if (node === legacyLead) {
            normalizedNodes.push(...Array.from(legacyLead.childNodes));
          } else {
            normalizedNodes.push(node);
          }
        });

        policyBody.replaceChildren(...normalizedNodes);
      }
    }

    const headings = Array.from(policyBody.querySelectorAll('h2'));
    if (!headings.length) return;

    document.body.classList.add('tr-shipping-policy-page');

    const sectionPrefix = currentPath === PRIVACY_PATH ? 'privacy' : 'shipping';
    const policyLabel = currentPath === PRIVACY_PATH ? 'Privacy policy' : 'Shipping policy';

    headings.forEach((heading, index) => {
      heading.id = `${sectionPrefix}-section-${index + 1}`;
    });

    const originalNodes = Array.from(policyBody.childNodes);
    const shell = document.createElement('div');
    const layout = document.createElement('div');
    const sidebar = document.createElement('aside');
    const sidebarTitle = document.createElement('div');
    const mobileNav = document.createElement('details');
    const mobileSummary = document.createElement('summary');
    const article = document.createElement('article');

    shell.className = 'tr-shipping-shell';
    layout.className = 'tr-shipping-layout';
    sidebar.className = 'tr-shipping-sidebar';
    sidebar.setAttribute('aria-label', `${policyLabel} sections`);
    sidebarTitle.className = 'tr-shipping-sidebar-title';
    sidebarTitle.textContent = 'On this page';
    mobileNav.className = 'tr-shipping-mobile-nav';
    mobileSummary.textContent = 'On this page';
    article.className = 'tr-shipping-article';

    sidebar.append(sidebarTitle, buildToc(headings));
    mobileNav.append(mobileSummary, buildToc(headings));
    originalNodes.forEach((node) => article.append(node));

    const firstParagraph = article.querySelector('p');
    const publishedMatch = firstParagraph?.textContent.match(/^\s*Published:\s*(.+)\s*$/i);
    if (publishedMatch) {
      firstParagraph.className = 'tr-shipping-meta';
      firstParagraph.replaceChildren();

      const badge = document.createElement('span');
      const date = document.createElement('strong');
      badge.textContent = 'Published';
      date.textContent = publishedMatch[1];
      firstParagraph.append(badge, date);
    }

    article.querySelectorAll('table').forEach((table) => {
      if (table.parentElement?.classList.contains('tr-shipping-table-scroll')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'tr-shipping-table-scroll';
      table.before(wrapper);
      wrapper.append(table);
    });

    layout.append(sidebar, article);
    shell.append(mobileNav, layout);
    policyBody.replaceChildren(shell);

    shell.addEventListener('click', (event) => {
      if (event.target.closest('.tr-shipping-mobile-nav a')) mobileNav.open = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceShippingPolicy, { once: true });
  } else {
    enhanceShippingPolicy();
  }
})();


